@use '@/scss/underscore' as _;

.anchor {
  display: inline-block;
}
